import { render, staticRenderFns } from "./brief-introduction.vue?vue&type=template&id=57faf5dc&scoped=true&"
import script from "./brief-introduction.vue?vue&type=script&lang=js&"
export * from "./brief-introduction.vue?vue&type=script&lang=js&"
import style0 from "./brief-introduction.vue?vue&type=style&index=0&id=57faf5dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57faf5dc",
  null
  
)

export default component.exports